import Frame from "../components/Frame";
import ui from "../components/ui.module.css";

const Checking = () => (
  <Frame centered>
    <p className={ui.meta} role="status">
      Getting ready…
    </p>
  </Frame>
);

export default Checking;
